import axios from 'axios';
import qs from 'qs';
import cookie from 'js-cookie';
import { ENV_CONFIG } from '@meiqia/constants';
import jsonpAdapter from './jsonp';

function getCustomMethod(params, method, token) {
  if (window.CUSTOM_CONFIG) {
    const methods = window.CUSTOM_CONFIG[window.CUSTOM_NAME].methods;
    if (method && methods.includes(method.toLowerCase())) {
      params.token = token;
      params._http_method = method;
      method = 'post';
    }
  }
  return method;
}

const fetch = ({
  url,
  method,
  params,
  data,
  headers,
  callbackParamName,
  jsonp,
  baseURL,
  onUploadProgress,
  deleteEntid
}) => {
  const entId = cookie.get('_enterprise_id');
  let queryParams = {
    ...params
  };
  // add by zhanghuan 上传文件不能传ent_id
  if (!deleteEntid && entId) {
    queryParams = {
      ent_id: entId,
      ...queryParams
    };
  }

  method = getCustomMethod(queryParams, method, cookie.get('_authenticated'));

  // console.log(queryParams);
  let options = {
    method,
    url,
    baseURL,
    params: queryParams,
    // add by wangxing 序列化参数
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    }
  };

  if (!baseURL) {
    options = { ...options, baseURL: `${ENV_CONFIG.MQ_API_URL}` };
  }
  if (headers) {
    headers = {
      ...headers,
      'X-Run-Env': encodeURIComponent(ENV_CONFIG.runEnv),
      'X-Run-Version': encodeURIComponent(ENV_CONFIG.runVersion)
    };
  }
  if (!headers) headers = {};

  if (method === 'jsonp') {
    options = { ...options, jsonp, callbackParamName: callbackParamName || 'c', adapter: jsonpAdapter };
  } else if (method === 'file') {
    const newHeaders = { ...headers };
    options = {
      ...options,
      headers: newHeaders,
      method: 'post',
      data,
      onUploadProgress
    };
  } else {
    const newHeaders = {
      ...headers,
      Accept: 'application/json',
      'Content-Type': headers['Content-Type'] || 'application/json'
    };
    options = { ...options, headers: newHeaders, data: JSON.stringify(data) ?? '' };
  }

  return new Promise((resolve, reject) => {
    axios(options)
      .then(res => {
        const { status } = res;
        if (status >= 200 && status < 300) {
          resolve({ data: res.data });
        }
      })
      .catch(err => {
        if (err && err.response && err.response.data) {
          reject(err.response);
        }
        reject(`${err}`);
      });
  });
};

export default fetch;
